module.exports = __webpack_public_path__ + "static/media/staffing-connect-timesheet-template.bf7a0321.pdf";